import { handleDeleteRequest, handleGetRequest, handlePostRequest, handlePutRequest } from '.';
import { URI } from '../../constants/URI';
import {
  setRestaurantPagination,
  setRestaurants,
  setRestaurantUser,
} from '../slices/restaurantSlice';
import { store } from '../store';

export const getRestaurants = async () => {
  const res = await handleGetRequest(URI.restaurants, null, {
    toast: false,
  });
  if (res?.ack) {
    store.dispatch(setRestaurants(res.restaurants));
    store.dispatch(setRestaurantPagination(res?.pagination));
  }
  return res;
};

export const addRestaurant = async (body) => {
  const res = await handlePostRequest(URI.add_restaurant, body);
  if (res?.ack) getRestaurants();
  return res;
};

export const updateRestaurant = async (body) => {
  const res = await handlePutRequest(URI.restaurant, body);
  if (res?.ack) getRestaurants();
  return res;
};

export const deleteRestaurant = async (body) => {
  const res = await handleDeleteRequest(URI.restaurant, body);
  if (res) getRestaurants();
  return res;
};

export const getRestaurantUsers = async (id, limit, page) => {
  const res = await handleGetRequest(URI.restaurant_user_by_id(id), null, {
    toast: false,
    params: { page, limit },
  });
  if (res?.ack) store.dispatch(setRestaurantUser(res.users));
  return res;
};

export const addUsersToRestaurant = async (body) => {
  const res = await handlePostRequest(URI.add_users_restaurant, body, {
    toast: false,
  });
  if (res?.ack) getRestaurantUsers(body.restaurant_id);
  return res;
};

export const deleteUsersFromRestaurant = async (body) => {
  const res = await handleDeleteRequest(URI.delete_user_restaurant, body);
  if (res?.ack) getRestaurantUsers(body.restaurant_id);
  return res;
};

export const getRestaurantsAnalytics = async () => {
  const res = await handleGetRequest(URI.restaurants_analytics, null, {
    toast: false,
  });
  return res;
};

export const getManagerRestaurantsAnalytics = async () => {
  const res = await handleGetRequest(URI.manager_restaurants_analytics, null, {
    toast: false,
  });
  return res;
};
